import { useMutation } from '@tanstack/react-query'

import { authServices } from '../authServices'
import { SignInDTO, SignInWithPhonePayload } from '../authTypes'

interface UseSignInWithPhoneOptions {
  onSuccess?: (data: SignInDTO) => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useSignInWithPhone = (options?: UseSignInWithPhoneOptions) => {
  return useMutation<SignInDTO, Error, SignInWithPhonePayload>({
    mutationFn: authServices.signInWithPhone,
    onSuccess: (data) => {
      options?.onSuccess?.(data)
    },
    onError: (error) => {
      options?.onError?.({
        errorMessage: error.message || 'Something went wrong',
        code: 'UNKNOWN_ERROR',
      })
    },
  })
}
